export default __webpack_public_path__ + "static/media/pizza-slice.8ec3be1b.png";